import React, { useState, useEffect } from 'react';
import { SetupScreen } from './CronogramaPersonalizado/SetupScreen';
import { Dashboard } from './CronogramaPersonalizado/Dashboard';
import api from '../services/api'; // Importa o serviço de API configurado

const CronogramaPersonalizadoPage = ({ onVoltar }) => {
  const [prefs, setPrefs] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Carregar o cronograma do usuário do backend
    const loadCronograma = async () => {
      try {
        const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : null;
        if (!token) {
          setLoading(false);
          return;
        }

        const config = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };

        const response = await api.get('/api/cronograma-personalizado', config);
        if (response.data.cronograma) {
          setPrefs(response.data.cronograma);
        } else {
          // Tenta carregar do localStorage como fallback
          const saved = localStorage.getItem('enem_planner_prefs');
          if (saved) {
            setPrefs(JSON.parse(saved));
          }
        }
      } catch (error) {
        console.error('Erro ao carregar cronograma:', error);
        // Tenta carregar do localStorage como fallback
        const saved = localStorage.getItem('enem_planner_prefs');
        if (saved) {
          setPrefs(JSON.parse(saved));
        }
      } finally {
        setLoading(false);
      }
    };

    loadCronograma();
  }, []);

  const handleSetupComplete = async (date, weeks, intensity, strategy) => {
    const newPrefs = {
      examDate: date,
      weeksAvailable: weeks,
      intensity: intensity,
      strategy: strategy,
      hasStarted: true,
      semanas: [] // Será preenchido quando o cronograma for gerado
    };

    try {
      // Salvar no backend
      const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : null;
      if (token) {
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };

        await api.post('/api/cronograma-personalizado', newPrefs, config);
      }
    } catch (error) {
      console.error('Erro ao salvar cronograma:', error);
      // Fallback para localStorage
      localStorage.setItem('enem_planner_prefs', JSON.stringify(newPrefs));
    }

    setPrefs(newPrefs);
  };

  const handleReset = async () => {
    try {
      // Remover do backend
      const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : null;
      if (token) {
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };

        await api.delete('/api/cronograma-personalizado', config);
      }
    } catch (error) {
      console.error('Erro ao resetar cronograma:', error);
    }

    localStorage.removeItem('enem_planner_prefs');
    setPrefs(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#9B4DFF] mx-auto mb-4"></div>
          <p className="text-gray-600">Carregando seu cronograma personalizado...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <main>
        {!prefs || !prefs.hasStarted ? (
          <SetupScreen onComplete={handleSetupComplete} />
        ) : (
          <Dashboard
            weeksAvailable={prefs.weeksAvailable}
            examDate={prefs.examDate}
            intensity={prefs.intensity || 'MODERATE'}
            strategy={prefs.strategy || 'PRIORITIZE_HIGH'}
            onReset={handleReset}
            onVoltar={onVoltar}
          />
        )}
      </main>
    </div>
  );
};

export default CronogramaPersonalizadoPage;